"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionalSearchIcon = exports.RegionalSearchInput = exports.RegionalContainer = exports.ItemCategory = exports.ItemTitle = exports.ItemContainer = exports.SuggestionContainer = exports.SearchIcon = exports.SearchInput = exports.Form = exports.SearchContainer = exports.Background = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const svg_components_1 = require("../../../../assets/svg-components");
const Typography_1 = __importDefault(require("../../../../Components/UI/Typography"));
exports.Background = styled_components_1.default.div `
  background-color: rgba(0, 0, 0, 0.4);
  top: 0;
  position: fixed;
  z-index: ${props => props.theme.attributes.zIndex.searchBackground};
  height: 100vh;
  width: 100%;
`;
exports.SearchContainer = styled_components_1.default.div `
  margin: ${props => props.theme.spacing.xl3}px auto 0 auto;
  width: ${props => props.theme.constants.searchWidth}px;
  background-color: ${props => props.theme.palette.BW_100};
  border-radius: ${props => props.theme.attributes.borderRadius.sm}px;
  &:focus-within {
    border: 1px solid ${props => props.theme.palette.ORANGE_100};
  }

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    background-color: ${props => props.theme.palette.BLUE_100};
    color: ${props => props.theme.palette.BW_100};
    width: 100%;
    border-radius: 0;
    margin-top: 0;
  }
`;
exports.Form = styled_components_1.default.form `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
exports.SearchInput = styled_components_1.default.input `
  padding: ${props => props.theme.spacing.m3}px 0 ${props => props.theme.spacing.m3}px
    ${props => props.theme.spacing.m3}px;
  border-radius: ${props => props.theme.attributes.borderRadius.sm}px;
  border: none;
  font-size: ${props => props.theme.typography.size.defaultSize}px;
  line-height: ${props => props.theme.typography.lineHeight.m2}px;
  font-weight: ${props => props.theme.typography.weight.regular};
  width: 100%;
  outline: none;

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    padding: ${props => props.theme.spacing.s5}px 0 ${props => props.theme.spacing.s5}px
      ${props => props.theme.spacing.s4}px;
    background-color: ${props => props.theme.palette.BLUE_100};
    color: ${props => props.theme.palette.BW_100};
    width: 80%;
    border-radius: 0;

    ::placeholder {
      color: ${props => props.theme.palette.BW_100};
    }
  }
`;
exports.SearchIcon = (0, styled_components_1.default)(svg_components_1.SearchIcon) `
  > path {
    stroke: ${props => props.theme.palette.LIGHT_BLACK};
  }
  margin: 0 ${props => props.theme.spacing.m3}px 0 ${props => props.theme.spacing.s4}px;
  cursor: pointer;

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    > path {
      stroke: ${props => props.theme.palette.BW_100};
    }
    margin-right: ${props => props.theme.spacing.s4}px;
  }
`;
exports.SuggestionContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  margin: ${props => props.theme.spacing.xs}px auto 0 auto;
  row-gap: ${props => props.theme.spacing.s2}px;
  background-color: ${props => props.theme.palette.BW_100};
  width: ${props => props.theme.constants.searchWidth}px;
  border-radius: ${props => props.theme.attributes.borderRadius.sm}px;
  padding: ${props => props.theme.spacing.m3}px;

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    border-radius: 0;
    width: 100%;
    margin: 0;
  }
`;
exports.ItemContainer = styled_components_1.default.button `
  display: flex;
  justify-content: column;
  justify-content: space-between;
  align-items: center;
  border: none;
  background-color: transparent;
`;
exports.ItemTitle = (0, styled_components_1.default)(Typography_1.default) `
  color: ${props => props.theme.palette.BLUE_100};
`;
exports.ItemCategory = (0, styled_components_1.default)(Typography_1.default) `
  color: ${props => props.theme.palette.DARK_GRAY_80};
`;
exports.RegionalContainer = styled_components_1.default.form `
  flex: 1;
  margin-right: ${props => props.theme.spacing.m6}px;
  margin-left: ${props => props.theme.spacing.m1}px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-radius: ${props => props.theme.attributes.borderRadius.sm}px;
  border: ${props => (props.isTransparent ? 'none' : `1px solid ${props.theme.palette.DARK_GRAY_20}`)};
  background-color: ${props => props.theme.palette.BW_100};
  &:focus-within {
    border: 1px solid ${props => props.theme.palette.ORANGE_100};
  }
`;
exports.RegionalSearchInput = styled_components_1.default.input `
  width: 100%;
  font-size: ${props => props.theme.typography.size.defaultSize}px;
  line-height: ${props => props.theme.typography.lineHeight.m2}px;
  font-weight: ${props => props.theme.typography.weight.regular};
  padding: ${props => props.theme.spacing.s1}px ${props => props.theme.spacing.s3}px;
  border: none;
  border-radius: ${props => props.theme.attributes.borderRadius.sm}px;
  outline: none;
`;
exports.RegionalSearchIcon = (0, styled_components_1.default)(svg_components_1.SearchIcon) `
  > path {
    stroke: ${props => props.theme.palette.LIGHT_BLACK};
  }
  margin-right: ${props => props.theme.spacing.s3}px;
  cursor: pointer;
`;
exports.default = {
    Background: exports.Background,
    SearchContainer: exports.SearchContainer,
    SearchInput: exports.SearchInput,
    SearchIcon: exports.SearchIcon
};
